export enum SyncObjectType {
  // Accounting
  CUSTOMER = 'CUSTOMER',
  ENTITY = 'ENTITY',
  BILLING_ACCOUNT = 'BILLING_ACCOUNT',
  PAYMENT_GATEWAY = 'PAYMENT_GATEWAY',
  INVOICE = 'INVOICE',
  ITEM = 'ITEM',
  PAYMENT = 'PAYMENT',

  // CRM
  CONTRACT = 'CONTRACT',
  ITEM_PRICE = 'ITEM_PRICE',

  SUBSCRIPTION = 'SUBSCRIPTION',
}
